import React from 'react'
import { UiCol, UiRowContainer } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,
    UiContentCol,

} from "../../components/common/UiPageElements";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import Footer from "../../components/footer/Footer";
import UiHowCampaignsWork from ".././../components/common/UiHowCampaignsWork";
import IncentiveBanner from './views/IncentiveBanner';
import nyImage from "../../../../styles/img/ttny.jpg";
import nyImage2 from "../../../../styles/img/ttny-2.jpg";
import nyImage3 from "../../../../styles/img/ttny-3.jpg";
import nyImage4 from "../../../../styles/img/ttny-4.jpg";
import { Button } from "react-bootstrap";
import { UiCardTitle } from '../../components/common/UiCardTitle';
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { TripFeatures } from './views/TripFeatures';
import { HowIncentiveWorks } from './views/HowIncentiveWorks';
import { TermsConditions } from './views/TermsConditions';
import sliderCardImage from '../../../../styles/img/slider-card.jpg';
import { Faq } from './views/Faq';
import { TickIcon } from '../../../../styles/img/svg/TickIcon';
import { UiLeftContentRightImageBlock } from '../../components/common/UiImageBlock';


export default function IncentivesPreRegister(props) {

    const wizardData = [
        { id: 1, number: "1", title: 'Step 1', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: 'disabled' },
        { id: 2, number: "2", title: 'Step 2', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: 'active' },
        { id: 3, number: "3", title: 'Step 3', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.' },
        { id: 5, number: <TickIcon />, title: 'Success', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: "success" },
    ];

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <IncentiveBanner
                    topText="Incentive"
                    title="Trip to NY
                5 Days All Inc"
                    description="Lorem Epsum You’re already working hard, enjoy
                various rewards you, your team and your family can enjoy."
                sliderCardImage={sliderCardImage}
                />

                <UiBannerBottomBar
                    prevPage="Campaigns"
                    prevPageLink="/ui"
                    currentPage="Sell 15 Premium Tickets"
                    currentPageLink="/ui/incentives-pre-register"
                />


                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiHowCampaignsWork title="How Campaigns Work"/>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>


                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiLeftContentRightImageBlock
                                    image1={nyImage}
                                    image2={nyImage2}
                                    image3={nyImage3}
                                    image4={nyImage4}
                                >
                                    <UiCardTitle title="Trip to New York!" />
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

                                    <hr />

                                    <h3>Win up to 20 Points</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu
                                    </p>

                                    <Button to="" className="sb-primary-btn--38">Join Incentive</Button>
                                </UiLeftContentRightImageBlock>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>


                <TripFeatures />

                <HowIncentiveWorks wizardData={wizardData} className="sb-ins-lg-wiz-4step" leftImage={true}/>

                <TermsConditions />

                <Faq />

                <Footer />

            </UiMainWrapper>
        </>
    )
}



